import React, { type HTMLAttributes } from 'react'

import { Link, type LinkProps } from '@tanstack/react-router'

import { cn } from '@/lib/utils'

export interface NavGroupItem extends LinkProps {
  label: string
}

export const NavGroup = React.forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ children, className, ...props }, ref) => (
    <div ref={ref} {...props} className={cn('flex flex-row items-center rounded-sm bg-gray-100 p-px', className)}>
      {children}
    </div>
  )
)

export const NavGroupItem = React.forwardRef<HTMLAnchorElement, NavGroupItem>(({ label, ...props }, ref) => (
  <Link
    ref={ref}
    {...props}
    className={'flex min-w-40 shrink-0 flex-row items-center justify-center rounded-sm px-3 py-0'}
    activeProps={{
      className: 'bg-white',
    }}
    inactiveProps={{
      className: 'hover:bg-gray-200 text-gray-300 hover:text-black',
    }}>
    {label}
  </Link>
))
